module.exports = new __parcel__URL__("avatar.15768afb.png").toString();